import { render, staticRenderFns } from "./IngredientPairPanel.vue?vue&type=template&id=00475672&scoped=true"
import script from "./IngredientPairPanel.vue?vue&type=script&lang=js"
export * from "./IngredientPairPanel.vue?vue&type=script&lang=js"
import style0 from "./IngredientPairPanel.vue?vue&type=style&index=0&id=00475672&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00475672",
  null
  
)

export default component.exports